export class DeviceDto {
    name: string;
    id : string;

    constructor(name: string, id: string){
        this.name = name;
        this.id = id;
    }
}